<template>

    <v-dialog
            dense
            data-app="true"
            v-model="showDialog"
            max-width="900px"
    >

        <toolbar-page title="Pending invitations">
            <template v-slot:buttons>
                <v-btn @click="closeDialog" id="closeDialogButton" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </toolbar-page>

        <v-data-table
                id="dataTable"
                :headers="headers"
                :items="invitations"
                class="elevation-1"
                :loading="loading"
                :footer-props="{itemsPerPageOptions: [10,25,50, -1]}"

        >
            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="item in items" :key="item.id">

                    <td class="text-left">{{ item.name }}</td>
                    <td class="text-left">{{ item.email }}</td>
                    <td class="text-left" v-if="!item.expired">{{ item.expires}}</td>
                    <td class="text-left" v-else>

                        <v-chip pill id="expired" color="red" text-color="white" class="ml-0">
                            <v-icon class="pr-1">mdi-alert-circle</v-icon>
                            Expired
                        </v-chip>
                    </td>
                    <td class="text-left">
                        <v-btn id="cancelInvitationButton"
                               @click="cancelInvitation(item.id, item.name)"
                               small
                               ripple
                               color="primary"
                        >
                            Cancel
                        </v-btn>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-data-table>

    </v-dialog>

</template>

<script>

    import ToolbarPage from "../../../../components/UI/ToolbarPage";

    export default {

        components: {
            ToolbarPage
        },

        props: ['showDialog', 'roles', 'invitations', 'loading'],

        data() {
            return {

                headers: [
                    {
                        text: 'NAME',
                        align: 'left',
                        sortable: true,
                        value: 'name'
                    },
                    {
                        text: 'EMAIL',
                        align: 'left',
                        sortable: false,
                        value: 'email'
                    },
                    {
                        text: 'EXPIRES',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {
                        text: 'ACTIONS',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },

                ],
            }
        },

        methods: {
            closeDialog() {
                this.$emit('close-dialog');
            },
            cancelInvitation(id, name) {
                this.$emit('cancel-invitation', id);
            },
        }
    }

</script>
